import { Mail, Phone, MapPin, Facebook, Instagram, Linkedin, ExternalLink } from "lucide-react";
import { useTheme } from "next-themes";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { theme } = useTheme();

  const footerSections = [
    {
      title: "Soluções",
      links: [
        { label: "Fluig Flows", href: "/flows" },
        { label: "FluigApps", href: "/flows" },
        { label: "Desenvolvimento Custom", href: "/flows" },
        { label: "Outsourcing Prime", href: "/flows" },
      ]
    },
    {
      title: "Empresa",
      links: [
        { label: "Sobre Nós", href: "/sobre" },
        { label: "Nossa Equipe", href: "/sobre" },
        { label: "Cases de Sucesso", href: "/contato" },
        { label: "Certificações", href: "/sobre" },
      ]
    },
    {
      title: "Suporte",
      links: [
        { label: "Central de Ajuda", href: "/contato" },
        { label: "Documentação", href: "/flows" },
        { label: "FAQ", href: "/contato" },
      ]
    }
  ];

  return (
    <footer className="bg-muted/30 dark:bg-fs-dark border-t border-border">
      <div className="container mx-auto px-6 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {/* Company Info */}
          <div className="space-y-6">
            <div className="flex items-center">
              <img
                src={theme === 'dark' ? '/logo-dark.png' : '/logo-light.png'}
                alt="Future Station"
                className="h-12 sm:h-16 md:h-20 lg:h-24 w-auto hover:scale-105 transition-transform duration-300"
              />
            </div>
            
            <p className="text-muted-foreground text-sm leading-relaxed">
              Especialistas em transformação digital com Fluig. 
              Mais de 50.000 horas de experiência em soluções corporativas.
            </p>

            {/* Contact Info */}
            <div className="space-y-3">
              <div className="flex items-center space-x-3 text-muted-foreground hover:text-foreground transition-colors">
                <Phone className="w-4 h-4 text-fs-cyan-500" />
                <span className="text-sm">(81) 98165-8439</span>
              </div>
              <div className="flex items-center space-x-3 text-muted-foreground hover:text-foreground transition-colors">
                <Mail className="w-4 h-4 text-fs-cyan-500" />
                <span className="text-sm">contato@futurestation.com.br</span>
              </div>
              <div className="flex items-center space-x-3 text-muted-foreground hover:text-foreground transition-colors">
                <MapPin className="w-4 h-4 text-fs-cyan-500" />
                <span className="text-sm">Olinda - Pernambuco, CEP 53.010-270</span>
              </div>
            </div>
          </div>

          {/* Footer Links Sections */}
          {footerSections.map((section) => (
            <div key={section.title} className="space-y-6">
              <h3 className="text-foreground font-semibold font-poppins text-lg">
                {section.title}
              </h3>
              <ul className="space-y-2 md:space-y-3">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-muted-foreground hover:text-foreground hover:fs-gradient-text transition-colors duration-300 text-sm flex items-center group"
                    >
                      {link.label}
                      <ExternalLink className="w-3 h-3 ml-1 opacity-0 group-hover:opacity-50 transition-opacity" />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div className="my-8 border-t border-border"></div>

        {/* Bottom Footer */}
        <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
          {/* Copyright */}
          <div className="text-muted-foreground text-sm">
            © {currentYear} Future Station. Todos os direitos reservados.
          </div>

          {/* Social Links */}
          <div className="flex items-center space-x-6 md:space-x-4">
            <span className="text-muted-foreground text-sm mr-2">Siga-nos:</span>
            <a
              href="https://www.facebook.com/profile.php?id=61574572664889"
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-fs-cyan-500 transition-colors duration-300"
              aria-label="Facebook"
            >
              <Facebook className="w-5 h-5" />
            </a>
            <a
              href="https://www.instagram.com/futurestationbr/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-fs-magenta-500 transition-colors duration-300"
              aria-label="Instagram"
            >
              <Instagram className="w-5 h-5" />
            </a>
            <a
              href="https://www.linkedin.com/company/future-station-br/posts/?feedView=all"
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-fs-purple-500 transition-colors duration-300"
              aria-label="LinkedIn"
            >
              <Linkedin className="w-5 h-5" />
            </a>
          </div>

          {/* Legal Links */}
          <div className="flex items-center space-x-4 text-sm">
            <a href="/privacidade" className="text-muted-foreground hover:text-foreground transition-colors">
              Privacidade
            </a>
            <a href="/termos" className="text-muted-foreground hover:text-foreground transition-colors">
              Termos
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;